import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCalendarChecked16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCalendarChecked16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 1.5a.5.5 0 0 0-1 0V2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1v-.5a.5.5 0 0 0-1 0V2H6zm4 2V3H6v.5a.5.5 0 0 1-1 0V3H4a1 1 0 0 0-1 1v2h10V4a1 1 0 0 0-1-1h-1v.5a.5.5 0 0 1-1 0M3 12V7h10v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1m3.604-2.354a.5.5 0 1 0-.708.708l1.306 1.305.353.353.354-.353 2.828-2.828a.5.5 0 1 0-.707-.708l-2.475 2.475z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCalendarChecked16);
